import type { useBuildLink } from "src/hooks/useBuildLink.ts";
import { type AppRouteKey, appRoutes } from "src/utils/appRoutes/appRoutes";

export type SidebarVisibilityContext = {
  isAdmin: boolean;
  isSuperAdmin: boolean;
  isDebugMode: boolean;
};

type BuildLink = ReturnType<typeof useBuildLink>;

export type SidebarEntry = {
  label: string;
  routeKey: AppRouteKey;
  getTo: (buildLink: BuildLink) => string;
  isVisible: (ctx: SidebarVisibilityContext) => boolean;
};

const alwaysVisible = () => true;

export const SIDEBAR_MAIN_ENTRIES: SidebarEntry[] = [
  {
    label: "Dashboard",
    routeKey: "dashboard",
    getTo: () => "/envs",
    isVisible: alwaysVisible,
  },
  {
    label: "Pipelines",
    routeKey: "apps",
    getTo: (buildLink) => buildLink("apps"),
    isVisible: alwaysVisible,
  },
  {
    label: "Compute",
    routeKey: "compute",
    getTo: (buildLink) => buildLink("compute"),
    isVisible: alwaysVisible,
  },
  {
    label: "Runs",
    routeKey: "runs",
    getTo: (buildLink) => buildLink("runs"),
    isVisible: alwaysVisible,
  },
  {
    label: "Compare Runs",
    routeKey: "compare-runs",
    getTo: () => appRoutes["compare-runs"].path,
    isVisible: alwaysVisible,
  },
  {
    label: "Datasets",
    routeKey: "datasets",
    getTo: (buildLink) => buildLink("datasets"),
    isVisible: alwaysVisible,
  },
  {
    label: "Alerts",
    routeKey: "alerts",
    getTo: (buildLink) => buildLink("alerts"),
    isVisible: alwaysVisible,
  },
];

export const SIDEBAR_ADMIN_ENTRIES: SidebarEntry[] = [
  {
    label: "Users",
    routeKey: "users",
    getTo: () => appRoutes.users.path,
    isVisible: ({ isAdmin }) => isAdmin,
  },
  {
    label: "License",
    routeKey: "license",
    getTo: () => appRoutes.license.path,
    isVisible: ({ isAdmin }) => isAdmin,
  },
  {
    label: "Super Admin",
    routeKey: "super-admin",
    getTo: () => appRoutes["super-admin"].path,
    isVisible: ({ isSuperAdmin, isDebugMode }) => isSuperAdmin && isDebugMode,
  },
];

export const SIDEBAR_ENTRIES = [...SIDEBAR_MAIN_ENTRIES, ...SIDEBAR_ADMIN_ENTRIES];
